export const data = [
  {
    title: "個人情報の管理",
    content:
      "当グループは、個人情報を適切に管理、保護する体制を形成し、個人情報の適切な利用、取得、提供などに関する規程を定め、これを遵守します。",
  },
  {
    title: "個人情報の取得",
    content:
      "当グループが個人情報を取得する場合、あらかじめ個人情報の利用目的を明示し、適法かつ公正な手段によって取得いたします。",
  },
  {
    title: "個人情報の利用目的",
    content: "当グループでは、以下の目的にのみ個人情報を利用しております。",
    itemList: [
      "マーケティングや商品開発等の統計的データとして利用するため",
      "応募・面接・採用に関する利用のため",
      "従業員の勤務および業務の管理のため",
      "お問合せの内容に対するお返事・謝礼をするため",
      "その他、何らかの理由で、お客様と連絡を取る必要が生じた時のため",
    ],
  },
  {
    title: "個人データの第三者提供",
    content:
      "法令に基づく場合を除き、本人の同意がない限り、個人データを第三者に対して提供いたしません。ただし、当グループと守秘義務契約を締結している業務の委託会社に対して、個人データを開示する場合がありますが、守秘義務契約に基づいた適切な管理、保護を行うよう監督いたします。また、法令に基づく開示請求のほか、警察や裁判所などの公的機関からの開示があった場合に、個人情報を開示・提供することがあります。",
  },
  {
    title: "開示・訂正・削除",
    content:
      "ご本人からの個人情報の開示、訂正、削除の請求を受けた場合、本人確認等を行ったうえで、合理的な範囲で速やかに対応いたします。",
  },
  {
    title: "苦情・相談",
    content:
      "本人から当社の個人情報保護に関する苦情、要望、相談を受けた場合、迅速かつ的確に対応し、内容に応じて適切な措置を行います。",
  },
  {
    title: "安全防止対策",
    content:
      "取得した個人情報の漏洩、紛失、改ざんなどの防止に努め、必要な安全管理対策を実施いたします。",
  },
  {
    title: "法令等の遵守",
    content: "個人情報の取り扱いに関する法令、指針、条令等を遵守いたします。",
  },
  {
    title: "個人情報管理体制の継続的な改善",
    content:
      "個人情報の取り扱い状況に対する定期的な社内教育等を実践し、継続的な改善に努めます。",
    content2:
      "上記の個人情報保護方針はすべての従業員に周知させ、従業員教育を通じ、個人情報保護に対する意識の向上を図ります。",
  },
  {
    title: "プライバシーポリシーの改善について",
    content:
      "フランソアグループは、お客様の個人情報を保護するために、このプライバシーポリシーを改定することがあります。改定後は、このページに掲載し、新方針を適用いたします。改定にあたり個々にお客様に通知することはありませんので、随時このページをご確認いただきますようお願いいたします。",
  },
  {
    title: "お問い合わせ",
    content:
      "お客様の個人情報に関するお問合せおよび開示請求等については、「会社に関するお問い合わせ」にて受け付けております。",
  },
]
